import { TaskService } from '@duck/api-definitions'
import { Badge } from '@duck/ui'
import { useTar } from '@/modules'
import { TASK_PROFICIENCIES } from '@/utils/taskProficiencies'

const ALL = Object.values(TaskService.TaskProficienciesEnum)

/** Toggleable badge per proficiency. Selected reads filled; unselected outlined. */
export const ProficiencyPicker = ({
  value,
  onToggle,
}: {
  value: TaskService.TaskProficienciesEnum[]
  onToggle: (p: TaskService.TaskProficienciesEnum) => void
}) => {
  const { t } = useTar()
  return (
    <div className="flex max-w-xl flex-wrap items-center justify-center gap-3">
      {ALL.map((p) => {
        const data = TASK_PROFICIENCIES[p]
        const active = value.includes(p)
        return (
          <button key={p} type="button" aria-pressed={active} onClick={() => onToggle(p)}>
            <Badge
              variant={active ? 'default' : 'outline'}
              className={`cursor-pointer gap-1.5 px-3 py-2 text-sm ${active ? '' : 'hover:border-accent/60'}`}
            >
              {data.icon('h-4 w-4')}
              <span className="capitalize">{t(data.label)}</span>
            </Badge>
          </button>
        )
      })}
    </div>
  )
}
